<div class="z-[1] flex w-full items-center justify-center">
  <div
    [proffeoSpinner]="isSubmitting()"
    class="relative flex w-full flex-col items-center gap-2 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface"
  >
    <div class="flex flex-col w-full items-center gap-2 p-4">
      <proffeo-ui-textarea
        [(value)]="commentText"
        [disabled]="isSubmitting()"
        [autosize]="true"
        [minRows]="1"
        [maxRows]="8"
        [autofocus]="shouldAutofocus()"
        placeholder="write-a-comment"
        variant="plain"
        class="flex w-full items-center"
      />
      <div class="flex w-full items-end justify-end gap-2">
        @if (files().length) {
          <proffeo-file-preview-list
            (removeFile)="onRemoveFile($event)"
            [files]="files()"
            class="w-full overflow-x-auto"
          ></proffeo-file-preview-list>
        }
        <div class="flex items-center gap-2">
          <proffeo-file-drop
            (filesAdded)="onFilesAdded($event)"
            mode="icon"
            class="ml-auto"
          ></proffeo-file-drop>
          <proffeo-ui-button
            (clicked)="onSendComment()"
            [disabled]="isSubmitting()"
            [text]="'task-description-comments.send-comment' | translate"
            variant="accent"
            fontIcon="send"
          ></proffeo-ui-button>
        </div>
      </div>
    </div>
  </div>
</div>
